__webpack_require__.p = "/apps/simple-editor/";